import React, { useEffect, useState } from "react";
import { Box, Button, useTheme } from "@mui/material";
import { Search as SearchIcon } from "lucide-react";
import InputCst from "@components/InputCst/InputCst";
import { ButtonSecondary } from "src/UI/ButtonSecondary";

interface SearchBarProps {
  initialValue?: string;
  onSubmit: (value: string) => void;
  placeholder: string;
  buttonLabel: string;
  filtersSlot?: React.ReactNode;
  liveSearch?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
  initialValue = "",
  onSubmit,
  placeholder,
  buttonLabel,
  filtersSlot,
  liveSearch = false,
}) => {
  const theme = useTheme();
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleSubmit = () => onSubmit(value.trim());

  const handleChange = (e: any) => {
    const next = e.target.value;
    setValue(next);
    if (liveSearch) onSubmit(next);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (!liveSearch && e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          flex: 1,
          "& .MuiFormControl-root": {
            minWidth: "0 !important",
            width: "100% !important",
          },
          "& .MuiFormHelperText-root": { display: "none" },
          "& .MuiOutlinedInput-root": { borderRadius: "8px" },
          "& .MuiOutlinedInput-notchedOutline": { borderRadius: "8px" },
        }}
        onKeyDown={handleKeyDown}
      >
        <InputCst
          id="searchable-multi-select-input"
          placeholder={placeholder}
          inputSearch
          value={value}
          onChange={handleChange}
          startAdornment={
            <SearchIcon
              size={16}
              color={theme.palette.systemSecondary01}
              style={{ marginRight: 8 }}
            />
          }
        />
      </Box>
      {!liveSearch && (
        <ButtonSecondary size="md" onClick={handleSubmit}>
          {buttonLabel}
        </ButtonSecondary>
      )}
      {filtersSlot}
    </Box>
  );
};

export default SearchBar;
